import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { seoSettingsRetailerAccessControl } from '../access-control/seoSettingsAccess.configuration'

const SeoSettingsRobotsTxtPage = lazy(() => import('../pages/robots-txt/SeoSettingsRobotsTxtPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const seoSettingsRouter = (
  <DomainRoute route="seo-settings" accessControl={seoSettingsRetailerAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="seo-settings-robots-txt" component={SeoSettingsRobotsTxtPage} />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
